import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface BathroomType {
  id: number;
  name: string;
}

const fetchBathroomTypes = async (): Promise<BathroomType[]> => {
  const response = await api.get<BathroomType[]>('/api/bathroom-types');
  return response.data;
};

export const useBathroomTypes = () => {
  const {
    data: bathroomTypes = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['bathroomTypes'],
    queryFn: fetchBathroomTypes,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 1,
    refetchOnWindowFocus: false
  });

  return {
    bathroomTypes,
    isLoading,
    error: error?.message || null,
    refetch
  };
};
